import styles from './PageHeaderAside.module.scss';

export interface IPageHeaderAsideProps {
    children: any;
}

export function PageHeaderAside(props: IPageHeaderAsideProps) {
    return (<div className={styles.host}>{props.children}</div>);
}
